import React from 'react';
import { useTranslation } from 'react-i18next';
import type { RequestOptions } from 'searchkit';
import type { QueryDslQueryContainer } from '@elastic/elasticsearch/lib/api/types';

import MetaSearch from '../../../../../components/Search/MetaSearch';

interface ORCIDPublicationsProps {
  publications: string[];
}

const ORCIDPublications: React.FC<ORCIDPublicationsProps> = (props) => {
  const { t } = useTranslation();

  const { publications } = props;

  const filters: QueryDslQueryContainer = {
    bool: {
      filter: [
        {
          bool: {
            must: {
              term: {
                entity_type: {
                  value: 'nioz_publication_orcid',
                },
              },
            },
          },
        },
        {
          bool: {
            should: [],
          },
        },
      ],
    },
  };

  publications.forEach((publication) => {
    // @ts-ignore
    filters.bool.filter[1].bool.should.push({
      term: {
        orcid_publication_id: {
          value: publication,
        },
      },
    });
  });

  const requestOptions: RequestOptions = {
    getBaseFilters: () => [
      filters,
    ],
  };

  return (
    <div className="ORCIDPublications">
      <h2 className="asH3">{t('content_types.profile.publications')}</h2>
      <MetaSearch
        requestOptions={requestOptions}
        contentType="nioz_publication_orcid"
        hitsPerPage={8}
        withPagination
      />
    </div>
  );
};

export default ORCIDPublications;
